import {assetUrl, assetId} from './constants';

const imageA = document.getElementById('imageA');
const imageB = document.getElementById('imageB');

const onError = () => {
  document.getElementById('error').style.display = 'flex';
};

imageA.onerror = onError;
imageB.onerror = onError;

export const setImageSizes = () => {
  const width = window.innerWidth;

  imageA.style.width = `${width}px`;
  imageB.style.width = `${width}px`;
};

export const setImageSources = () => {
  imageA.src = `${assetUrl}/${assetId}/frame-000.png`;
  imageB.src = `${assetUrl}/${assetId}/frame-001.png`;

  setImageSizes();
};
